import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { DealRentTrapContainer } from './DealRentTrap.container';

app.component(
  'dealRentTrapAfterFp',
  react2angular(
    DealRentTrapContainer,
    ['goToNextStep', 'applyDealRent', 'dealRentCost', 'isMobile', 'analyticsOfferStatus'],
    ['config', 'httpApi', 'logger'],
  ),
);
